/* eslint-disable jsx-a11y/anchor-is-valid */
import * as classnames from 'classnames'
import * as React from 'react'

import { customerMarketShopfrontApi } from '@envato/foundation-types'

import { IBlockMatchedComponent } from '../../../pages/category/category'
import SafeInnerHtml from '../../safeInnerHtml'

import * as styles from './articleBlock.module.css'

interface IProps extends IBlockMatchedComponent {
  data: customerMarketShopfrontApi.categoryPage.IArticleBlockData
}

interface IState {
  hidden: boolean
}

class ArticleBlock extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { hidden: true }
    this.toggleHidden = this.toggleHidden.bind(this)
  }

  public render() {
    const { data } = this.props
    const { hidden } = this.state

    return (
      <article className={styles.root}>
        <h2 className={styles.title}>{data.title}</h2>
        <div className={styles.panelWrapper}>
          <a
            role="link"
            className={styles.expandBtn}
            onClick={this.toggleHidden}
          >
            Read {hidden ? 'more' : 'less'}
          </a>
          <div
            className={classnames({
              [styles.panelPreview]: hidden,
              [styles.panelFull]: !hidden
            })}
          >
            <SafeInnerHtml html={data.htmlContent} />
          </div>
          <div
            className={classnames({
              [styles.showFade]: hidden,
              [styles.hideFade]: !hidden
            })}
          />
        </div>
      </article>
    )
  }

  private toggleHidden() {
    this.setState({ hidden: !this.state.hidden })
  }
}

export default ArticleBlock
